import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { store } from './app/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
// import "./assets/css/material-dashboard-react.css?v=1.8.0";
import "./assets/scss/material-dashboard-pro-react.scss?v=1.8.0";
import UserProvider from "./providers/UserProvider";

ReactDOM.render(
  <UserProvider>
    <Provider store={store}>
      <App />
    </Provider>
  </UserProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
